import React, { useRef, useEffect, useState } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { XR, useXR } from '@react-three/xr';
import { Leva } from 'leva';
import { NoToneMapping } from 'three';
import { useSnapshot } from 'valtio';

import HomepageTopper from './HomepageTopper';
import { XRButton, XRScene, DOMOverlay } from './XRScene';
import { state, toggleDomOverlay } from './XRScene/state';

// Auto hide non-XR content when entering XR
function NonXRContent({ children, forceHide }) {
  const { isPresenting } = useXR();
  if (isPresenting || forceHide) return null;
  return children;
}

export function App() {
  const domOverlayRef = useRef();
  const { runFallback } = useSnapshot(state);

  const [data, setData] = useState(null);
  const [isHomepage, setIsHomepage] = useState(window.location.pathname === '/');
  const [showControls, setShowControls] = useState(false);

  window.setIsHomepage = setIsHomepage;

  // add ?debugXR to the querystring to debug the XR content without going into XR
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.href.includes('debugXR')) {
      document.querySelector(`.js__xrCanvas`).style.opacity = 1;
      state.runFallback = true;
    } else {
      const data = window.flowersData || null; // CMS data
      data && setData(data);
    }
  }, [setData]);

  // add a ?showControls to the querystring to show the controls
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.href.includes('showControls')) {
      setShowControls(true);
    }
  }, [setShowControls]);

  return (
    <>
      <div className={'js__xrButton'}>
        <XRButton domOverlayRef={domOverlayRef} />
      </div>

      <DOMOverlay ref={domOverlayRef} />

      <div className={'js__xrCanvas'} style={{ zIndex: runFallback ? 1000 : 1 }}>
        <Canvas
          gl={{ alpha: true, antialias: true }}
          dpr={[1, 2]}
          onPointerMissed={() => {
            toggleDomOverlay();
          }}>
          {/* Wrap everything in the XR provider so we can listen to `isPresenting` */}
          <XR
            foveation={1}
            onSessionEnd={() => {
              state.requestedVR = false;
              state.requestedAR = false;
            }}>
            <NonXRContent forceHide={runFallback}>
              <HomepageTopper show={isHomepage} />
            </NonXRContent>

            <XRScene data={data} />
          </XR>
        </Canvas>
      </div>
      <Leva hidden={!showControls}/>
    </>
  );
}
